import { Link } from 'gatsby'
import React from 'react'
import Logo from '../logo'

export const FooterNavigation = () => {
  const footerLinks: Record<
    string,
    {
      title: string
      link: string
      isExternal?: boolean
      label?: string
    }[]
  > = {
    Ressources: [
      {
        link: '/je-suis-un-cabinet#tarifs',
        title: 'Consultation des tarifs',
        label: 'Tarifs',
      },
      {
        link: '/cabinets/lamacompta',
        title: 'Qui est derrière Lamacompta.co ?',
        label: 'We are Lamacompta',
      },
      {
        link: 'https://ressources.lamacompta.co',
        title: 'Accéder au blog de Lamacompta',
        label: 'Blog Lamacompta',
        isExternal: true,
      },
    ],
    "Offres d'emploi": [
      {
        link: '/offres',
        title: 'Voir les offres d’emploi sur Lamacompta.co !',
        label: 'Offres',
      },
      {
        link: '/offres/categories',
        title: 'Voir les offres d’emploi par métiers sur Lamacompta.co !',
        label: 'Liste des offres par métiers en cabinet',
      },
    ],
    Cabinets: [
      {
        link: '/je-suis-un-cabinet',
        title: 'Je veux recruter sur Lamacompta.co !',
        label: 'Je suis un cabinet',
      },
      {
        link: '/liste-des-cabinets',
        title: 'Voir la liste des cabinets sur Lamacompta.co !',
        label: 'Liste des cabinets',
      },
      {
        link: '/cabinets/groupements',
        title: 'Voir la liste des groupements de cabinets sur Lamacompta.co !',
        label: 'Liste des groupements',
      },
    ],
  }

  return (
    <div className="grid grid-cols-1 gap-6 lg:gap-10 md:grid-cols-3 lg:grid-cols-4">
      <div className="hidden md:block md:w-2/3">
        <Logo />
      </div>
      {Object.entries(footerLinks).map(([category, links]) => (
        <div key={category} className="space-y-2 lg:space-y-4">
          <p className="text-base font-semibold underline md:text-sm text-night md:no-underline">
            {category}
          </p>
          <ul role="menu" className="space-y-2">
            {links.map(({ title, link, isExternal, label }) => (
              <li role="menuitem" key={title}>
                {isExternal ? (
                  <a
                    key={title}
                    title={title}
                    href={link}
                    target="_blank"
                    className="text-sm font-thin transition-colors duration-300 ease-in-out hover:underline text-night"
                    rel="noreferrer"
                  >
                    {label || title}
                  </a>
                ) : (
                  <Link
                    key={link}
                    to={link}
                    title={title}
                    className="text-sm font-thin transition-colors duration-300 ease-in-out hover:underline text-night"
                  >
                    {label || title}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}
